import { render, staticRenderFns } from "./ExternalUsersEditor.vue?vue&type=template&id=236b0327"
import script from "./ExternalUsersEditor.vue?vue&type=script&lang=ts"
export * from "./ExternalUsersEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports